export * from "./ConfiguracaoClipping";
